import React from 'react';
import { BLOG_POSTS_DATA } from '../constants';

const Blog: React.FC = () => {
  return (
    <section id="blog" className="py-20 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Blog y Consejos de Salud</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
            Mantente informado con artículos y consejos de nuestros especialistas para una vida más saludable.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {BLOG_POSTS_DATA.map((post, index) => (
            <div key={index} className="bg-gray-50 dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden flex flex-col">
              <img 
                aria-label="Post de blog"
                name="Post de blog"
                id="Post de blog"
                width="500"
                height="500"
                src={post.image} 
                alt={post.title} 
                className="w-full h-48 object-cover" />
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-secondary dark:text-white mb-2">{post.title}</h3>
                <p className="text-gray-600 dark:text-gray-300 flex-grow">{post.excerpt}</p>
                 <a href="#" className="mt-6 font-semibold self-start text-primary">
                    Leer más &rarr;
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;